// @flow
import {useMemo} from 'react';
import React, {useState} from 'react';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
//$FlowFixMe
import dayJsUtils from '@date-io/dayjs';
import {
  Checkbox,
  FormGroup,
  FormControlLabel,
  Grid,
  Typography,
} from '@material-ui/core';

import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';

import CustomButton from '../CustomButton/CustomButton';
import CustomModal from '../CustomModal/CustomModal';
import CustomDatePicker from '../../modules/marketing/coupons/components/CustomDatePicker/CustomDatePicker';
import {makeURL} from '../../modules/orders/utils';
import type {OrderState} from '../../entities';
type Props = {
  open: boolean,
  handleClose: () => void,
  statesSelected?: OrderState[],
};
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 670,
    padding: '1.5rem 0',

    [theme.breakpoints.down('xs')]: {
      maxWidth: '80%',
      overflowX: 'hidden',
    },
  },
  title: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '1.2rem',
    marginBottom: '20px',
  },
  filter: {
    textAlign: 'left',
    color: '#3A3A49',
    fontWeight: 600,
    marginBottom: '0.5rem',
  },
  button: {
    height: 40,
    width: '18rem',
    fontSize: '1rem',
    fontWeight: 600,
    padding: '6px 50px',
  },
  listEstado: {
    display: 'flex',
    flexDirection: 'column',
  },
  nameEstado: {
    fontSize: '1rem',
    color: '#3A3A49',
    fontWeight: 'normal',
  },
  containerDates: {
    width: '20rem',
    margin: '1rem 0',
  },
  containerButtonDownload: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '3rem',
  },
}));

const filterOpts = [
  {
    label: 'Pendiente',
    value: 'PENDING',
  },
  {
    label: 'Aceptado',
    value: 'CONFIRMED',
  },
  {
    label: 'Pagado',
    value: 'PAID',
  },
  {
    label: 'En ruta',
    value: 'ON_THE_WAY',
  },
  {
    label: 'Entregado',
    value: 'DELIVERED',
  },
  {
    label: 'Cancelados',
    value: 'CANCELLED',
  },
];
export default function DownloadModal(props: Props) {
  const {open, handleClose, statesSelected} = props;
  const classes = useStyles();

  const [localStatesSelected, setLocalStatesSelected] = useState(
    statesSelected
  );

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [availableEnd, setAvailableEnd] = useState(false);

  const handleStateOption = (state: OrderState) => {
    if (localStatesSelected) {
      if (localStatesSelected.indexOf(state) === -1)
        setLocalStatesSelected([...localStatesSelected, state]);
      else setLocalStatesSelected(localStatesSelected.filter(e => e !== state));
    }
  };

  const handleChangeDate = (date?: Date, type: string) => {
    if (date) {
      if (type === 'start') {
        setAvailableEnd(false);
        setStartDate(date);
        setAvailableEnd(true);
      } else {
        setEndDate(date);
      }
    }
  };

  const urlDownload = useMemo(() => {
    return makeURL({
      filters: localStatesSelected,
      start: startDate,
      end: endDate,
    });
  }, [endDate, localStatesSelected, startDate]);

  const isDisabled = useMemo(
    () =>
      !(
        localStatesSelected &&
        localStatesSelected.length &&
        startDate &&
        endDate
      ),
    [localStatesSelected, startDate, endDate]
  );
  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        <div className={classes.modalDownloadContent}>
          <Typography className={classes.title}>Descargar Reporte</Typography>
          <div className={classes.containerFilter}>
            <Typography className={classes.filter}>Estado:</Typography>
            <div className={classes.listEstado}>
              <FormGroup>
                {filterOpts.map(({label, value}, i) => (
                  <FormControlLabel
                    key={`option-${i}`}
                    control={
                      <Checkbox
                        color="primary"
                        checked={
                          localStatesSelected &&
                          localStatesSelected.includes(value)
                        }
                        onChange={() => handleStateOption(value)}
                      />
                    }
                    label={
                      <Typography className={classes.nameEstado}>
                        {label}
                      </Typography>
                    }
                  />
                ))}
              </FormGroup>
            </div>
            <Typography className={classes.filter}>Fecha:</Typography>

            <div className={classes.containerDates}>
              <Grid container spacing={2}>
                <MuiPickersUtilsProvider utils={dayJsUtils}>
                  <Grid item xs={12}>
                    <CustomDatePicker
                      label="Desde"
                      handleChange={date => handleChangeDate(date, 'start')}
                      value={startDate}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CustomDatePicker
                      disabled={!availableEnd}
                      label="Hasta"
                      handleChange={date => handleChangeDate(date, 'end')}
                      value={endDate}
                      minDate={startDate}
                      minDateMessage={
                        'La fecha debe ser posterior a la fecha de inicio'
                      }
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>
            </div>
          </div>
          <div className={classes.containerButtonDownload}>
            <CustomButton
              variant="contained"
              className={classes.button}
              disabled={isDisabled}
              href={urlDownload}
              target="_blank"
              rel="noopener noreferrer"
            >
              Descargar
            </CustomButton>
          </div>
        </div>
      </div>
    </CustomModal>
  );
}

DownloadModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
